import bg from '../assets/bg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.jpg';
import phohalong from '../assets/phohalong.png';

const images = {
  bg,
  spoon,
  welcome,
  findus,
  phohalong
};

export default images;
